import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import BlackButton from '../../../../components/BlackButton';
import init from '../../AccessControl/Check';
import { MAX_UPLOAD_FILE_SIZE } from '../../../../components/Constants/FileUpload';

const CreateBusinessCategory = () => {
    const pageName = "Business Category Add";
    const isAccess = init(pageName);
    
    const fileInput = useRef();
    const [file, setFile] = useState("");
    
    const selectFile = () => {
        fileInput.current.click();
    }
    
    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }
        
        setFile(e.target.files[0]);
    }
    
    
    const [input, setInput] = useState({
        name: "",
        position: ""
    });
    
    
    const navigate = useNavigate();
    const onSubmit = (e) => {
        e.preventDefault();

        if (input?.name === "") {
            toast.error("Please enter category name.");
            return;
        }

        if(file === null || file === undefined || file === "") {
            toast.error("Please enter category icon.");
            return;
        }

        let requestBody = new FormData();
        requestBody.append("name", input.name);
        requestBody.append("icon", file);
        requestBody.append("position", input.position ?? null);


        // Create Category API
        PostLoginPostApi("business/category", requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 201) {
                    toast.success("Category create successfully.");
                    navigate("/dashboard/category");
                    return;
                }

                toast.error(responseData["messages"].toString() ??  responseData["message"].toString() + "");
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/category"><CloseBtn className="float-left" /></Link>
                <p className="text-center">Create Business Category</p>
            </header>
            <main className="max-w-2xl m-auto">

                <form onSubmit={onSubmit}>
                    <h1 className="text-lg">Business Category Name</h1>
                    <div className="mt-2 mb-[15px]">
                        <input type="text" name="name" placeholder="Enter Business Category Name *" value={input?.name} 
                        onChange={(event) => setInput({...input, name: event.currentTarget.value ?? ""})} 
                        className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" required />
                    </div>

                    <h1 className="text-lg">Business Category Icon</h1>
                    <div className="flex pb-2 pt-1 mb-4 items-center">
                        <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                            <input type="file" className="hidden" name="icon" ref={fileInput} onChange={handleChange} />
                            <label htmlFor="icon" className="p-1 text-base font-medium">Icon *</label>
                            {file ?
                                <>
                                    <img src={URL.createObjectURL(file)} alt="Preview Icon" className="max-h-10 max-w-10 ml-auto order-3" />
                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[8px] px-[10px] rounded-[3px] cursor-pointer text-sm" onClick={selectFile}>Change</button>
                                </> :
                                <>
                                    <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Upload Icon</button>
                                </>
                            }

                        </div>
                    </div>


                    <h1 className="text-lg">Business Category Position</h1>
                    <div className="mt-2 mb-[25px]">
                        <input type="number" name="position" value={input?.position} 
                        onChange={(event) => setInput({...input, position: event.currentTarget.value?? ""})} 
                        placeholder="Enter Business Category Position" className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" />
                    </div>

                    <BlackButton name="Add Business Category" />
                </form>

            </main>
        </div>
    );
};

export default CreateBusinessCategory;